import Code from '@tiptap/extension-code'

// Based on https://github.com/ueberdosis/tiptap/issues/2563#issuecomment-1078852349
export const CodeNoExcludes = Code.extend({ excludes: '' })
